<template>
    <b-form-input
        v-model="searchQuery"
        placeholder="Filtrar persona / empresa"
        size="sm"
    />
</template>
<script>
import { EventNames } from '@/plugins/enums'

export default {
    name: 'SearchLegalEntity',

    data() {
        return {
            searchQuery: ''
        }
    },

    methods: {
        filteredItems() {
            this.$eventBus.$emit(EventNames.FilterLegalEntityAfterSearch, this.searchQuery);
        }
    },

    watch: {
        'searchQuery'() {
            this.filteredItems();
        }
    }

}
</script>
